import React from 'react'

import PageLoader from 'Layout/PageLoader'

import { useGetAppQuery } from './zapier.service'
import ManageZapier from './ManageZapier'
import InstallZapier from './InstallZapier'

const Zapier = () => {
  const { isLoading, isError, error, data: zapier = {} } = useGetAppQuery(null)

  if (isLoading) {
    return <PageLoader />
  }

  if ((isError && error.status === 404) || !zapier.is_active) {
    return <InstallZapier />
  }

  return <ManageZapier {...zapier} />
}

export default Zapier
